@if (showHashTagModal && !showDiscard) {
  <div class="modal fade slide-in-bottom" id="tagsModal" tabindex="-1" aria-labelledby="tagsModal" aria-hidden="true" data-backdrop="static" [ngStyle]="{'display': (showHashTagModal && !showDiscard) ? 'block' : 'none','opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
    <div class="modal-dialog modal-dialog-centered modal-md w-700">
      <div class="modal-content">
        <div class="modal-header">
          <h1>Add Hashtags</h1>
          <button type="button" class="modal-close close btn-pos" data-dismiss="modal" aria-label="Close" (click)="showDiscardModal()">
            <!-- <span class="Neueclosefilled"></span>
            <em class="esc d-none d-lg-inline-block">esc</em> -->
            <span [ngClass]="[universalService.isMobileDevice ? 'Neueclosefilled' : 'NeueFile_Cancel']"></span>
            <span class="esc">esc</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- Tagging Main -->
          <div class="tagging-main mt-xl-2">
            <div class="tag-input-wrap">
              <div class="inpt-wrap">
                <!--(keypress)="fetchUpdatedTag(tagName.value,$event)"
                -->
                <form [formGroup]="tagForm" autocomplete="off">
                  @if (!implRef.maxLimitError) {
                    <span class="hash">#</span>
                  }
                  @if (!implRef.maxLimitError || !this.universalService.show2FApopUp) {
                    <input formControlName="tagName" #tagNameInput type="text" id="tagInput" class="inpt-tags" value="{{implRef.currentTagName}}" oninput="this.value = this.value.replace(' ', '')" (click)="implRef.focusOnInputField()" (input)="fetchUpdatedTag(tagNameInput.value,$event)"
                      (keydown.enter)="addTagOnEnter(tagNameInput.value)" (blur)="addTagOnBlur(tagNameInput.value,$event)" autofocus autocomplete="off" (keydown)="showTagsSuggestion($event)" (keyup)="hideTagsSuggestion($event)" />
                  }
                  @if (implRef.maxLimitError || this.universalService.show2FApopUp) {
                    <input type="text" class="inpt-tags disabled" placeholder="{{placeholderText}}" readonly/>
                  }
                </form>
              </div>
              <!-- Note/Error -->
              <div class="note-n-error">
                @if (implRef.hashTagError.msg != '') {
                  <p [ngClass]="{'error-txt':implRef.hashTagError.type == 'error'}">{{implRef.hashTagError.msg}}</p>
                }
                <span class="float-right NeueFiles_Info" title="Click for more info" (click)="showInformation()" id="hashTagInfoBtn"></span>
                <!-- <popover-content #infoPopover title="" placement="bottom" [animation]="true" [closeOnClickOutside]="true" [closeOnMouseOutside]="false"> -->
                @if (showInfoModal) {
                  <app-hash-tag-info (closeInfo)="showInformation()"/>
                }
              <!-- </popover-content> -->
              <!-- <p class="error-txt" style="display: none;">Tagging requires an internet connection.</p> -->
            </div>
            <!-- suggestion list -->
            @if (this.implRef.showTagAutoSuggestion) {
              <div class="jc-tag-suggestion-dropdown fade-in-fwd" >
                @if (tagSuggestions.tagList.length > 0) {
                  <div class="jc-tag-suggestion-list" >
                    @for (sugg of tagSuggestions?.tagList; track sugg) {
                      <div class="row m-0 p-0 suggestionRow" tabindex="2" id="{{sugg}}" (click)="addSuggestedTagToObject(sugg)">
                        <div class="col-1 p-0 text-center tag-icon Neuetag"></div>
                        <div class="p-0 col-11 tag-name-search">
                          <span  [innerHTML]="sugg | txtHighlight : this.tagName"></span>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            }
            <!-- Tags Scrollable -->
            <div class="tags-scrollable">
              <!-- Tags Main -->
              <div class="tags-main">
                <!-- Tags Selected -->
                <ul>
                  @for (tag of implRef.existingTagsList; track tag) {
                    <li class="selected">{{tag.tag}}<span class="Neueclosefilled" title="Remove tag" (click)="removeTag(tag)"></span></li>
                  }
                  @for (tag of implRef.newTagsList; track tag) {
                    <li class="selected">{{tag}}<span class="Neueclosefilled" title="Remove tag" (click)="removeTag(tag)"></span></li>
                  }
                </ul>
              </div>
              @if (showHashTagModal) {
                <app-recent-hash-tags/>
              }
            </div>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <div class="modal-footer">
        <div class="btn-wrap">
          <button [ngClass]="{'disabled':!implRef.enableButton}" (click)="saveChanges()">Save</button>
        </div>
      </div>
    </div>
  </div>
</div>
}

@if (showDiscard) {
  <app-discard-hash-tags (keepChange)="discardConfirmation('no')" (dontSave)="discardConfirmation('yes')"/>
}